export default __webpack_public_path__ + "static/media/tenancy.5ca8778c.ttf";